// extracted by mini-css-extract-plugin
export default {"FaqAskQuestion":"ol_a bhf_qr bhf_a bhf_w","FaqAskQuestion__outdated":"ol_b bhf_vp bhf_xe"};